// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_Top5BucketsChartCard_card__7pwmM {
  overflow: hidden;
}

.storage_Top5BucketsChartCard_card__7pwmM h5 {
  padding: 16px 0 16px 16px;
}

.storage_Top5BucketsChartCard_chartTitleContainer__AgmGz {
  display: flex;
  align-items: center;
  gap: 8px;
}

.storage_Top5BucketsChartCard_tooltipIcon__hwYLb {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.storage_Top5BucketsChartCard_cardContentWithPadding__msALZ {
  position: relative;
  overflow: auto;
  padding: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/Top5BucketsChartCard/Top5BucketsChartCard.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf","sourcesContent":[".card {\n  overflow: hidden;\n}\n\n.card h5 {\n  padding: 16px 0 16px 16px;\n}\n\n.chartTitleContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tooltipIcon {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.cardContentWithPadding {\n  position: relative;\n  overflow: auto;\n  padding: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `storage_Top5BucketsChartCard_card__7pwmM`,
	"chartTitleContainer": `storage_Top5BucketsChartCard_chartTitleContainer__AgmGz`,
	"tooltipIcon": `storage_Top5BucketsChartCard_tooltipIcon__hwYLb`,
	"cardContentWithPadding": `storage_Top5BucketsChartCard_cardContentWithPadding__msALZ`
};
export default ___CSS_LOADER_EXPORT___;
